import { Box, Stack } from "@mui/material";
import React from "react";
import { css, keyframes } from "@emotion/react";

import { Color, FontStyle } from "../constants";
import { useMediaQuery } from "react-responsive";

// within the survey
// not to be confused with the heart button in the job panel

const tease = () => keyframes`
    0% {
        transform: scale(1);
    }
    10% {
        transform: scale(1.025);
    }
    100% {
        transform: scale(1);
    }
`;
const styles = {
  container: {
    // backgroundColor: Color.primary,
    border: `1px solid ${Color.borderGray}`,
    position: "relative",
    backgroundColor: "white",
    color: "black",
    borderRadius: "0.75rem",
    padding: "0.69rem 1.5rem",
    // margin: '0.48rem 0.48rem 0px 0px',
    cursor: "pointer",
    userSelect: "none",
    textAlign: "center",
    // width: "fit-content",
    backgroundColor: "white",
    "&:hover": {
      animation: `${tease()} 0.3s ease-in-out 0s`,
    },
  },
  containerDisabled: {
    color: "rgb(122, 122, 104)",
    cursor: "",
    "&:hover": {},
  },
  selected: {
    backgroundColor: Color.primary,
  },
  text: {
    ...FontStyle.body,
    fontSize: "16px",
    transition: "all 0.3s ease-in-out 0s",
    width: "fit-content",
    // transform: 'translateX(-0.7rem)',
  },
  textSelected: {
    transform: "translateX(0.75rem)",
  },
  icon: {
    position: "absolute",
    left: "0.75rem",
    transition: "all 0.3s cubic-bezier(0.8, 1.64, 0.6, 1) 0s",
    opacity: 0,
    transform: "translateY(-50%)",
  },
  iconSelected: {
    opacity: 1,
    transform: "scale(1)",
  },
};

const HeartButton = ({ text, selected, setSelected, disabled }) => {
  const mobile = useMediaQuery({ query: "screen and (max-width: 510px)" });
  return (
    <Stack
      direction="row"
      sx={{
        ...styles.container,
        ...(selected && styles.selected),
        ...(disabled && styles.containerDisabled),
      }}
      onClick={() => setSelected(!selected)}>
      <Box sx={{ ...styles.icon, ...(selected && styles.iconSelected) }}>
        {/* 🍑 */}
        ❤️
      </Box>
      {text === "Corporate Social Responsiblity & Sustainability" && mobile ? (
        <>
          {/* fix because a 'fit-content' box has too much paddingX when the last word wraps */}
          <Stack direction="column" alignItems="center">
            <Box sx={{ ...styles.text, ...(selected && styles.textSelected) }}>
              {"Corporate Social Responsiblity &"}
            </Box>
            <Box sx={{ ...styles.text, ...(selected && styles.textSelected) }}>
              {"Sustainability"}
            </Box>
          </Stack>
        </>
      ) : (
        <Box sx={{ ...styles.text, ...(selected && styles.textSelected) }}>
          {text}
        </Box>
      )}
    </Stack>
  );
};

export default HeartButton;
